import React from "react";

import { FileGeneratorUI } from "./components";

const SubmissionHistory = () => {
  return (
    <FileGeneratorUI
      scope="SUBMISSION_HISTORY|ALL|V1"
      title="Generate Submission History CSV File."
      entity="submission_history"
    />
  );
};

export { SubmissionHistory };
